// Optimized and modified based on the provided WELSH EDUCATION GROUP content,
// without skipping any lines or changing functionality.

export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Offline Courses",
    desc: "Join WELSH EDUCATION GROUP for flexible Offline classes taught by experienced educators. Access high-quality lectures, practice materials, and support from anywhere.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Earn A Certificates",
    desc: "Enhance your credentials with recognized certificates from WELSH EDUCATION GROUP. Showcase your expertise and stand out in both academic and professional fields.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Learn with Expert",
    desc: "Our dedicated faculty provides personalized instruction, ensuring deeper understanding and successful exam preparation.",
  },
]

export const awrapper = [
  {
    cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "1,000+",
    title: "SUCCESS STORIES",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "5+",
    title: "TRUSTED TUTORS",
  },
  {
    cover: "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
    data: "1,00",
    title: "SCHEDULES",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "15+",
    title: "COURSES",
  },
]

export const coursesCard = [
  {
    id: 1,
    // cover: "../images/courses/c1.png",
    coursesName: "course 1",
    courTeacher: [
      {
        dcover: "./logo-removebg.png",
        name: "by WELSH EDUCATION GROUP",
        totalTime: "Daily Practice & Weekly Tests",
      },
    ],
    priceAll: "₹5,000 Full Course",
    pricePer: "₹700 per month",
  },
  {
    id: 2,
    // cover: "../images/courses/c2.png",
    coursesName: "course 2",
    courTeacher: [
      {
        dcover: "./logo-removebg.png",
        name: "by WELSH EDUCATION GROUP",
        totalTime: "In-depth Concepts & Regular Test Series",
      },
    ],
    priceAll: "₹8,000 Full Course",
    pricePer: "₹1,000 per month",
  },
  {
    id: 3,
    // cover: "../images/courses/c3.png",
    coursesName: "course 3",
    courTeacher: [
      {
        dcover: "./logo-removebg.png",
        name: "by WELSH EDUCATION GROUP",
        totalTime: "Advanced Problem-Solving & Mock Tests",
      },
    ],
    priceAll: "₹10,000 Full Course",
    pricePer: "₹1,500 per month",
  },
  {
    id: 4,
    cover: "../images/courses/c4.png",
    coursesName: "Competitive Exams: Basic Foundation (Upcoming)",
    courTeacher: [
      {
        dcover: "./logo-removebg.png",
        name: "by WELSH EDUCATION GROUP",
        totalTime: "Short Tricks & Conceptual Clarity",
      },
    ],
    priceAll: "₹6,000 Full Course",
    pricePer: "₹800 per month",
  },
  {
    id: 5,
    cover: "../images/courses/c5.png",
    coursesName: "Competitive Exams: Full-Length Mock Series (Upcoming)",
    courTeacher: [
      {
        dcover: "./logo-removebg.png",
        name: "by WELSH EDUCATION GROUP",
        totalTime: "Extensive Mock Tests & Analysis",
      },
    ],
    priceAll: "₹4,000 Full Course",
    pricePer: "₹500 per month",
  },
  {
    id: 6,
    cover: "../images/courses/c6.png",
    coursesName: "Upcoming Online Course on Udemy: Mathematics Basics",
    courTeacher: [
      {
        dcover: "./logo-removebg.png",
        name: "by WELSH EDUCATION GROUP",
        totalTime: "Video Lectures & Practice Sessions",
      },
    ],
    priceAll: "₹2,500 Full Access",
    pricePer: "₹400 per month",
  },
  // {
  //   id: 7,
  //   cover: "../images/courses/c7.png",
  //   coursesName: "Offline Course on Udemy: Physics Fundamentals",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by WELSH EDUCATION GROUP",
  //       totalTime: "Step-by-Step Concept Explanations",
  //     },
  //   ],
  //   priceAll: "₹3,000 Full Access",
  //   pricePer: "₹450 per month",
  // },
  // {
  //   id: 8,
  //   cover: "../images/courses/c8.png",
  //   coursesName: "Classes 6-10: Science Booster Course",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by WELSH EDUCATION GROUP",
  //       totalTime: "Real-Life Examples & Problem-Solving",
  //     },
  //   ],
  //   priceAll: "₹4,500 Full Course",
  //   pricePer: "₹600 per month",
  // },
  // {
  //   id: 9,
  //   cover: "../images/courses/c9.png",
  //   coursesName: "Classes 6-10: Mathematics Drill Sessions",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by WELSH EDUCATION GROUP",
  //       totalTime: "50 Lectures (Fundamental to Advanced)",
  //     },
  //   ],
  //   priceAll: "₹3,500 Full Course",
  //   pricePer: "₹500 per month",
  // },
]

export const online = [
  {
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
    courseName: "Classes 6-10 Offline",
    course: "Mathematics & Science",
  },
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Classes 11-12 Offline",
    course: "Mathematics & Physics",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Competitive Exams",
    course: "Upcoming Courses",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "Mock Tests & Assessments",
    course: "Weekly & Full-Length",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Foundation Courses",
    course: "Classes 6-8",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Board Exam Focus",
    course: "Classes 9-10",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Advanced Prep",
    course: "Classes 11-12",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "Online Workshops",
    course: "Upcoming Crash Courses",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Subject-Specific",
    course: "Math / Physics",
  },
  // {
  //   cover: "./images/courses/online/o10.png",
  //   hoverCover: "./images/courses/online/o10.1.png",
  //   courseName: "Science Modules",
  //   course: "Practical & Theory",
  // },
  // {
  //   cover: "./images/courses/online/o11.png",
  //   hoverCover: "./images/courses/online/o11.1.png",
  //   courseName: "Reasoning & Logic",
  //   course: "Competitive Focus",
  // },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Udemy Specials",
    course: "Upcoming Flexible Learning",
  },
]

export const team = [
  {
    cover: "https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-859.jpg?ga=GA1.1.777668748.1709143233&semt=ais_hybrid&w=740",
    name: "Dr. Ram Krishan Sharma",
    work: "FOUNDER | Managing Director",
  },
  // {
  //   cover: "https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-859.jpg?ga=GA1.1.777668748.1709143233&semt=ais_hybrid&w=740",
  //   name: "Er. Shubham Kumar",
  //   work: "CO-FOUNDER | MATHEMATICS & SCIENCE SPECIALIST",
  // },
  // {
  //   cover: "./images/team/01.jpg",
  //   name: "Er. Atul Sharma",
  //   work: "MATHEMATICS & REASONING MENTOR",
  // },
  // {
  //   cover: "./images/team/t4.webp",
  //   name: "Ph.D Brian Wooden",
  //   work: "GUEST LECTURER | ADVANCED PHYSICS",
  // },
  // {
  //   cover: "./images/team/t5.webp",
  //   name: "Ph.D Adrian Molises",
  //   work: "SENIOR MENTOR | COMPETITIVE EXAMS",
  // },
  // {
  //   cover: "./images/team/t6.webp",
  //   name: "Ph.D Arthur MaGregor",
  //   work: "ASSOCIATE INSTRUCTOR | SCIENCE",
  // },
  // {
  //   cover: "./images/team/t7.webp",
  //   name: "Ph.D Anna Hanzen",
  //   work: "ASSOCIATE INSTRUCTOR | MATHEMATICS",
  // },
  // {
  //   cover: "./images/team/t8.webp",
  //   name: "Ph.D Brian Wooden",
  //   work: "SENIOR LECTURER | PHYSICS & RESEARCH",
  // },
]

export const price = [
  {
    name: "BASIC PLAN",
    price: "₹4,999",
    desc: "Ideal for foundational learning with access to essential materials and weekly practice tests.",
  },
  {
    name: "BEGINNER PLAN",
    price: "₹7,999",
    desc: "Perfect for students seeking structured coursework, doubt sessions, and monthly assessments.",
  },
  {
    name: "PREMIUM PLAN",
    price: "₹10,999",
    desc: "Comprehensive plan including advanced modules, mock exams, and personalized mentorship.",
  },
  {
    name: "ULTIMATE PLAN",
    price: "₹14,999",
    desc: "All-inclusive package with detailed study material, 1-on-1 sessions, and full-length test series.",
  },
]

export const faq = [
  { title: "How to Enroll in These Offline Courses?", desc: "Simply visit our website or our institute, select your desired course, and For Enrolment feel free to contact us at 9115400982, 9115400980." },
  { title: "What Are the Key Benefits of Joining WELSH EDUCATION GROUP?", desc: "We offer expert faculty, structured courses, affordable fees, regular assessments, and small batches to provide personalized attention." },
  { title: "Are There Any Free Trial Classes?", desc: "Yes, we occasionally provide free demo sessions so students can experience our teaching style before enrolling." },
  { title: "How Often Are Mock Tests Conducted?", desc: "Mock tests are conducted weekly or monthly—depending on the course. Full-length mock exams are provided prior to major exams." },
  { title: "Is There Any Personalized Doubt Resolution?", desc: "Absolutely. Our small batch sizes and dedicated doubt-solving sessions ensure every student’s questions are addressed promptly." },
];

/* ── Page-specific FAQ datasets ── */
export const faqHome = [
  { title: "What skill programs does Welsh Education offer?", desc: "We offer industry-focused skill programs in AI & Machine Learning, Animation & VFX, Digital Marketing, Data Science, AR/VR, and Robotics designed to build real-world expertise." },
  { title: "Are these skill programs suitable for beginners?", desc: "Yes, our programs are designed for beginners as well as intermediate learners. No prior experience is required to get started." },
  { title: "How are skill programs different from traditional courses?", desc: "Our programs focus on practical learning, real-world projects, and career outcomes rather than just theoretical knowledge." },
  { title: "Do you provide job or placement support?", desc: "Yes, we provide career guidance, portfolio building, interview preparation, and access to our hiring partner network." },
  { title: "Can I enroll in skill programs while planning to study abroad?", desc: "Yes, many students choose to build skills alongside their study abroad preparation to improve their career opportunities." },
  { title: "Which countries can I apply to for study abroad?", desc: "We assist students in applying to countries like Germany, UK, Canada, Australia, and other global destinations." },
  { title: "Is IELTS mandatory for study abroad?", desc: "It depends on the country and university. Some universities offer alternatives or accept students without IELTS under certain conditions." },
  { title: "How can I choose the right program for my career?", desc: "You can book a free counseling session, and our experts will guide you based on your interests and career goals." },
  { title: "Do you provide practical training in your programs?", desc: "Yes, all programs include hands-on learning and real-world project experience to ensure practical knowledge." },
  { title: "How can I get started with Welsh Education?", desc: "You can explore our skill programs or book a free counseling session to begin your journey." },
];

export const faqCourses = [
  { title: "How do I choose the right course?", desc: "Use our course pages to compare outcomes, or talk to our counselor for a quick assessment." },
  { title: "Are EMI options available?", desc: "Yes, monthly plans are available on most courses." },
];

export const faqServices = [
  { title: "What services are included?", desc: "Career counseling, visa assistance, accommodation guidance, tests, document verification, and insurance support." },
  { title: "Is counseling free?", desc: "The first basic counseling is free; advanced packages are available." },
];

export const faqVisa = [
  { title: "Which documents are needed for visa?", desc: "Valid passport, photographs, financial proofs, admission/offer letters, and any country-specific forms." },
  { title: "Do you help with interview prep?", desc: "Yes, we provide mock interviews and checklists." },
];

export const faqAccommodation = [
  { title: "Do you arrange hostels or PGs?", desc: "We recommend verified partners and help shortlist options based on budget and distance." },
  { title: "Can I change later?", desc: "Yes, we assist with relocation guidance as needed." },
];

export const faqCareer = [
  { title: "Do you offer profile reviews?", desc: "Yes—resume, SOP/essay reviews, and counseling sessions." },
  { title: "Can you help with course mapping?", desc: "We align your interests with suitable programs and institutes." },
];

export const faqTestPrep = [
  { title: "What tests do you prepare for?", desc: "Board exams, foundational competitive sections, and mock series." },
  { title: "Are mock tests included?", desc: "Yes, weekly and monthly mocks depending on the plan." },
];

export const faqDocuments = [
  { title: "What documents are verified?", desc: "Academic transcripts, IDs, income/financial docs, and supporting certificates." },
  { title: "How long does verification take?", desc: "Usually 3–7 working days depending on the document type." },
];

export const faqInsurance = [
  { title: "Do you provide travel insurance?", desc: "We assist in selecting appropriate coverage for students and travelers." },
  { title: "Is health insurance mandatory?", desc: "Some countries mandate health insurance for students—check your destination’s rules." },
];

export const faqCountry = [
  { title: "What if my destination changes?", desc: "We help remap your plan, documentation, and timelines for the new country." },
  { title: "Are scholarships available?", desc: "Yes—varies by country and institute. We help you shortlist and apply." },
];

export const faqBlog = [
  { title: "Can I suggest topics?", desc: "Absolutely! Send us your topic ideas via the contact page." },
  { title: "Do you accept guest posts?", desc: "We’re open to high-quality, original contributions." },
];

export const faqContact = [
  { title: "What are your working hours?", desc: "Mon–Sat, 10:00 AM – 7:00 PM IST." },
  { title: "How can I reach quickly?", desc: "Call 9115400982 / 9115400980 or use WhatsApp from the floating button." },
];


export const blog = [
  {
    id: 1,
    type: "admin",
    date: "JAN. 18, 2025",
    com: "3 COMMENTS ",
    title: "Study Techniques for Board Exams",
    desc: "Discover proven strategies to tackle board exams with confidence. Learn time-management tips, effective note-taking methods, and more.",
    cover: "../images/blog/b1.webp",
  },
  {
    id: 2,
    type: "admin",
    date: "APR. 25, 2024",
    com: "5 COMMENTS ",
    title: "Preparing for Competitive Exams",
    desc: "Get insights on how to crack competitive exams with targeted study plans, short tricks, and expert advice.",
    cover: "../images/blog/b2.webp",
  },
  {
    id: 3,
    type: "user",
    date: "MAY. 15, 2024",
    com: "10 COMMENTS ",
    title: "Mastering Mathematics Essentials",
    desc: "A closer look at understanding core math concepts for high scores in exams and deeper subject mastery.",
    cover: "../images/blog/b3.webp",
  },
  {
    id: 4,
    type: "admin",
    date: "JAN. 02, 2025",
    com: "3 COMMENTS ",
    title: "Tips for Better Science Revision",
    desc: "Learn quick revision strategies, practical experiment tips, and memory techniques to excel in Science.",
    cover: "../images/blog/b4.webp",
  },
  {
    id: 5,
    type: "admin",
    date: "DEC. 14, 2024",
    com: "3 COMMENTS ",
    title: "Success Stories at WELSH EDUCATION GROUP",
    desc: "Read inspiring testimonials of students who achieved remarkable results with our courses and test series.",
    cover: "../images/blog/b5.webp",
  },
  {
    id: 6,
    type: "user",
    date: "JAN. 18, 2025",
    com: "12 COMMENTS ",
    title: "Offline Learning Advantages",
    desc: "Explore how offline learning can offer flexibility, convenience, and a personalized pace for every student.",
    cover: "../images/blog/b6.webp",
  },
]

export const testimonal = [
  {
    id: 1,
    name: "Mohit Kumar",
    post: "Student",
    desc: "Excellent guidance and smooth visa process support. Highly satisfied with Welsh Education Group.",
    cover: "/images/testo/t1.webp",
  },
  {
    id: 2,
    name: "Mehak Khatri",
    post: "Student",
    desc: "Very professional team and personalized counseling for every step. I felt supported throughout.",
    cover: "/images/testo/t2.webp",
  },
  {
    id: 3,
    name: "Kalpna",
    post: "Student",
    desc: "Friendly staff, quick responses, and real help in university admission. Strongly recommend.",
    cover: "/images/testo/t3.webp",
  },
  {
    id: 4,
    name: "Lalit Kumar Singh",
    post: "Student",
    desc: "The training provided here is top-notch. It truly helped me gain the practical skills needed for my career.",
    cover: "",
  },
]
